module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    class: _vm.colorType
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26a263ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAText.vue
// module id = 500
// module chunks = 1